import { useCallback, useEffect, useRef, useState } from "react";
import { Loader2, RotateCcw } from "lucide-react";
import api from "@/lib/api";

const MAX_WAIT = 150000;

export function useAiJob(url, params, open, client = api, extra = {}) {
  const [d, setD] = useState(null);
  const [run, setRun] = useState(0);
  const timer = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    const t0 = Date.now();
    setD(null);
    const fail = (error) => alive && setD({ status: "error", error });
    const poll = () => client.get(url, { params, timeout: 20000, ...extra }).then(next).catch(() => wait());
    const wait = () => {
      if (!alive) return;
      if (Date.now() - t0 > MAX_WAIT) return fail("L'analisi sta impiegando troppo tempo. Riprova tra poco.");
      timer.current = setTimeout(poll, 4000);
    };
    function next(r) {
      if (!alive) return;
      setD({ ...r.data, elapsed: Math.round((Date.now() - t0) / 1000) });
      if (r.data.status === "running") wait();
    }
    client.post(url, null, { params, timeout: 60000, ...extra }).then(next).catch((e) => fail(e.response?.data?.detail || "Connessione non riuscita, riprova"));
    return () => { alive = false; clearTimeout(timer.current); };
  }, [open, url, run]); // eslint-disable-line react-hooks/exhaustive-deps
  const retry = useCallback(() => setRun((x) => x + 1), []);
  return [d, retry];
}

export const AiLoading = ({ d, text, accent, testid }) => (
  <div className="flex items-start gap-2 py-8 text-sm text-neutral-400" data-testid={testid}>
    <Loader2 className="mt-0.5 h-5 w-5 shrink-0 animate-spin" style={{ color: accent }} />
    <div>
      <p data-testid={`${testid}-fase`}>{d?.fase || text}</p>
      {d?.elapsed > 0 && <p className="mt-1 text-[11px] text-neutral-600" data-testid={`${testid}-elapsed`}>{d.elapsed} s · massimo 90 s</p>}
    </div>
  </div>
);

export const AiError = ({ error, onRetry, accent, testid }) => (
  <div className="flex flex-wrap items-center gap-3 py-4" data-testid={testid}>
    <p className="text-sm text-red-400">{error || "Analisi non riuscita"}</p>
    <button type="button" onClick={onRetry} className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-colors hover:bg-white/5"
      style={{ borderColor: accent, color: accent }} data-testid={`${testid}-retry`}>
      <RotateCcw className="h-3.5 w-3.5" />Riprova
    </button>
  </div>
);
